import React, {useState, useEffect} from "react";
import Login from "./login";
import './topbar.scss';

function Topbar (props) {
    const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
        let token = JSON.parse(localStorage.getItem('token'));
        if (!token) {
            setShowLogin(true);
        }
    }, [])
    
    function closeLogin () {
        let token = JSON.parse(localStorage.getItem('token'));
        if (!token) {
            return;
        }

        setShowLogin(false);
    };

    return (
        <div className="topbar">
            <div className="userIcon"
            onClick={() => setShowLogin((showLogin) => !showLogin)}></div>
            <div className="version">0.0.0.1Beta</div>
            { showLogin ? <Login close={() => closeLogin()}></Login> : ''}
        </div>
    )    
}

export default Topbar;